import React, { useCallback, useEffect, useState } from "react";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import Table from "components/Tabla/Table";
import { useSnackbar } from "notistack";
import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

const ListaMovimientos = ({
  numeroCuenta,
}) => {
  const [listMovimientos, setListMovimientos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fechaInicial, setFechaInicial] = useState(moment().add(-1, "month"));
  const [fechaFinal, setFechaFinal] = useState(moment());

  const { enqueueSnackbar } = useSnackbar();

  const searchMovimientos = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Api(
        `${endpoints.listadoMovimientosFecha}/${numeroCuenta}/${fechaInicial.format("YYYY-MM-DD")}/${fechaFinal.format("YYYY-MM-DD")}`,
        "GET",
        null
      )
      setListMovimientos(response);
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, fechaFinal, fechaInicial, numeroCuenta]);

  useEffect(() => {
    searchMovimientos()
  }, [searchMovimientos])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <DatePicker
          label="Fecha Inicial"
          value={fechaInicial}
          onChange={setFechaInicial}
          renderInput={(params) => <TextField fullWidth {...params} />}
          disableFuture
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePicker
          label="Fecha Final"
          value={fechaFinal}
          minDate={fechaInicial}
          onChange={setFechaFinal}
          renderInput={(params) => <TextField fullWidth {...params} />}
          disableFuture
        />
      </Grid>
      <Grid item xs={12}>
        <Table
          id={listMovimientos.codigo}
          title="LISTADO DE MOVIMIENTOS"
          columns={[
            {
              title: "PRODUCTO",
              field: "nombreProducto",
              width: 150,
            },
            {
              title: "TRANSACCION",
              field: "nombreTrasaccion",
              width: 110,
            },
            {
              title: "FECHA",
              field: "fechaRegistro",
              align: "center",
              width: 110,
            },
            {
              title: "DEB/CRE",
              field: "debitoCredito",
              align: "center",
              width: 110,
            },
            {
              title: "OBSERVACION",
              field: "observacion",
              width: 110,
            },
            {
              title: "VALOR TRANSACCION",
              field: "valorTransaccion",
              align: "right",
              width: 150,
            },
            {
              title: "VALOR SALDO",
              field: "valorSaldo",
              align: "right",
              width: 150,
            },
          ]}
          data={listMovimientos}
          loading={loading}
        />
      </Grid>
    </Grid>
  );
}

export default ListaMovimientos